import React from 'react';

const SignsSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 13h1V7h5v8h-6v-2zM3 12h12V4H3v8zM2 3v10h6.5v8h1v-8H14v3h3.5v5h1v-5H22V6h-6V3H2z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 9h8v1H5zM5 6h8v1H5z"
        />
    </svg>
);

SignsSvg.displayName = 'SignsSvg';
export default SignsSvg;
